import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { fulfillmentOptions } from 'cart/constants/fulfillmentOptions';

const useStyles = makeStyles(({ palette }) => ({
  root: ({ hasAction }) => ({
    borderBottom: `2px solid ${palette.secondary.main}`,
    paddingBottom: '6px',
    cursor: hasAction ? 'pointer' : 'inherit',
    '&:hover': {
      color: hasAction ? palette.secondary.main : 'inherit'
    }
  })
}));

const TITLE_BY_FULFILLMENT_METHOD = {
  [fulfillmentOptions.DINE_IN]: 'Dine-In',
  [fulfillmentOptions.DELIVERY]: 'Delivery',
  [fulfillmentOptions.PICKUP]: 'Pickup'
};

const CartHeader = ({ fulfillmentMethod, onClick }) => {
  const hasAction = !!onClick;
  const classes = useStyles({ hasAction });

  return (
    <Box mb={1} display="flex">
      <Typography variant="h2">Your&nbsp;</Typography>
      {hasAction && (
        <Link
          component="button"
          onClick={onClick}
          variant="h2"
          className={classes.root}
          underline="none"
        >
          {TITLE_BY_FULFILLMENT_METHOD[fulfillmentMethod]}
        </Link>
      )}
      {!hasAction && (
        <Typography variant="h2" className={classes.root} underline="none">
          {TITLE_BY_FULFILLMENT_METHOD[fulfillmentMethod]}
        </Typography>
      )}
      <Typography variant="h2">&nbsp;Order</Typography>
    </Box>
  );
};

CartHeader.propTypes = {
  fulfillmentMethod: PropTypes.string.isRequired,
  onClick: PropTypes.func
};

CartHeader.defaultProps = {
  onClick: null
};

export default CartHeader;
